export const onEnterKey =
  <T extends React.KeyboardEvent>(handler: (e: T) => void) =>
  (e: T): void => {
    if (e.key === 'Enter' || e.key === ' ') {
      handler(e);
    }
  };
